import React, { useEffect } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Terms & Conditions
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                <i>Terms & Conditions</i>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pb-10">
          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">1. Use of the Website</p>
            <p>
              &nbsp; 1.1. You agree to use the Website only for lawful purposes
              and in accordance with these Terms.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">
              2. Intellectual Property
            </p>
            <p>
              &nbsp; 2.1. All content and materials available on the Website,
              including but not limited to text, graphics, logos, images, and
              software, are the property of Init Technology or its licensors and
              are protected by copyright, trademark, and other intellectual
              property laws.
            </p>

            <p className="mt-2 lg:mt-4">
              &nbsp; 2.2. You may not modify, reproduce, distribute, transmit,
              display, perform, or create derivative works of any content or
              materials from the Website without the prior written consent of
              Init Technology.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">3. Privacy Policy</p>
            <p>
              &nbsp; 3.1. Your use of the Website is subject to Init
              Technology's Privacy Policy, which is incorporated into these
              Terms by reference. Please review the Privacy Policy carefully to
              understand how Init Technology collects, uses, and protects your
              personal information.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">
              4. Limitation of Liability
            </p>
            <p>
              &nbsp; 4.1. Init Technology shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages, including
              but not limited to lost profits, arising from or in connection
              with your use of the Website or any services offered through the
              Website.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">5. Governing Law</p>
            <p>
              &nbsp; 5.1. These Terms shall be governed by and construed in
              accordance with the laws of [Your Jurisdiction], without regard to
              its conflict of law principles.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">6. Changes to Terms</p>
            <p>
              &nbsp; 6.1. Init Technology reserves the right to modify or revise
              these Terms at any time. Any changes to these Terms will be
              effective immediately upon posting on the Website. Your continued
              use of the Website after any such changes constitutes your
              acceptance of the revised Terms.
            </p>
          </div>

          <div className="my-5 lg:my-8">
            <p className="font-semibold my-2 md:my-4">7. Contact Information</p>
            <p>
              &nbsp; 7.1. If you have any questions or concerns about these
              Terms, please contact us at&nbsp;
              <a
                href="mailto:contact@inittechnology.co"
                className="underline hover:text-[#008080]"
              >
                contact@inittechnology.co
              </a>
              <span className="font-light"> or </span>
              <a
                href="tel:+919664570369"
                className="underline hover:text-[#008080]"
              >
                +91-96645 70369
              </a>
            </p>
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default TermsAndConditions;
